import defaults from '../config/default/config.json';
import configConnect from 'preconf';

const configure = configConnect(null, defaults);
export { defaults, configure };
